(function () {
  // A. Only one video may carry sound at any moment
  document.addEventListener('play', function (e) {
    if (!e.target || e.target.tagName !== 'VIDEO') return;
    document.querySelectorAll('video').forEach(function (v) {
      if (v !== e.target && !v.muted) v.pause();
    });
  }, true);

  // B. A video that is not visible must never play
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        if (v.dataset.pausedByGuard === '1' && v.muted) {
          v.play().catch(function () {});
          delete v.dataset.pausedByGuard;
        }
      } else if (!v.paused) {
        v.pause();
        v.dataset.pausedByGuard = '1';
      }
    });
  }, { threshold: 0 });

  function observeAll() {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.dataset.videoGuard) return;
      v.dataset.videoGuard = '1';
      io.observe(v);
    });
  }

  observeAll();
  document.addEventListener('DOMContentLoaded', observeAll);
  document.addEventListener('shopify:section:load', observeAll);
})();